"use client";

import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { useState } from "react";

const navLinks = [
  { href: "/", label: "Home" },
  { href: "/services", label: "Services" },
  { href: "/packages", label: "Packages" },
  { href: "/about", label: "About" },
  { href: "/contact", label: "Contact" },
];

export default function Navbar() {
  const pathname = usePathname();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 w-full z-50 glass-nav shadow-[0_20px_50px_rgba(168,85,247,0.04)]">
      <div className="flex justify-between items-center px-8 py-6 max-w-screen-2xl mx-auto">
        <Link href="/" className="flex items-center gap-3 group transition-transform hover:scale-[1.02]">
          <Image
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuAz5Zkeu1kM3cQsvS_HJMvArVHKe7AkuuToua9cadp29g8X8VTqxsor_U5c3SfTKyxSg4V2-6hT9Fuyf2cbJ8l8pap2WdyKISCoriGhHKSlzXTZmpm_pHHm06p6xxdM-GDaz5qWLboPogh7xOQkykmTOyiwcWgDmh5E9T1Bk8jYBEJR4e_6eeuDOHK-bAzGnKY2pKYiSuJRc6ykGTF-VmAnQxmEMoQliiHQACVOa9AOOdYn47EUz5ZDCR4-7gNpKQM_-aw_0TpXZJQ"
            alt="VALARTECH logo"
            width={40}
            height={40}
            className="w-10 h-10 object-contain"
            unoptimized
          />
          <span className="text-2xl font-black tracking-tighter text-white font-headline uppercase">VALARTECH</span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className={`font-headline uppercase tracking-widest text-sm transition-colors ${
                pathname === link.href
                  ? "text-primary border-b-2 border-primary pb-1"
                  : "text-gray-400 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <Link
            href="/contact"
            className="bg-primary hover:bg-primary-container text-on-primary font-bold px-6 py-2.5 rounded-full transition-all duration-300 transform active:scale-95 text-sm uppercase tracking-wider font-headline"
          >
            Free Digital Check
          </Link>
          <button
            className="lg:hidden p-2 text-white flex items-center justify-center"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className="material-symbols-outlined text-3xl">
              {menuOpen ? "close" : "menu"}
            </span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden px-8 border-t border-white/5 overflow-hidden transition-all duration-300 ${
          menuOpen ? "max-h-96 opacity-100 pb-6" : "max-h-0 opacity-0"
        }`}
      >
        <div className="flex flex-col space-y-4 pt-6">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className={`font-headline uppercase tracking-widest text-sm transition-colors ${
                pathname === link.href
                  ? "text-primary"
                  : "text-gray-400 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
